<template>
  <div>
    <PageHeader :title="title" :items="items">
      <i
        class="bx bxs-help-circle font-size-20 div-clickable"
        @click="iniciarTour()"
      ></i>
    </PageHeader>
    <div class="row">
      <b-card data-v-step="1">
        <b-card-title class="text-end">
          <router-link to="/cooperado/rdv/carteira/solicitarAdiantamento">
            <b-button variant="primary" class="mb-2 btn-lg" data-v-step="2">
              <i class="bx bx-plus"></i> Solicitar Adiantamento
            </b-button>
          </router-link>
        </b-card-title>
        <b-table
          responsive="sm"
          :fields="camposListaAdiantamento"
          :items="montaDetalhes(listaAdiantamento)"
          per-page="10"
          :current-page="currentPage"
          data-v-step="3"
        >
          <template v-slot:cell(status)="data">
            <span
              class="badge badge-pill font-size-12"
              :class="{
                'badge-soft-primary': data.value === 'Enviado',
                'badge-soft-danger': data.value === 'Rejeitado',
                'badge-soft-warning': data.value === 'Em Análise',
                'badge-soft-info': data.value === 'Aprovação do Tomador',
                'badge-soft-success': data.value === 'Aprovado',
              }"
            >
              {{ data.value }}
            </span>
          </template>
          <template #row-details="data">
            <div class="d-flex" data-v-step="4">
              <div class="col-md-6">
                <div class="bg-soft bg-warning" style="width: 98%">
                  <thead role="rowgroup">
                    <tr role="row">
                      <th role="columnheader">Finalidade do Uso</th>
                    </tr>
                  </thead>
                  <tbody role="rowgroup">
                    <tr role="row" class="b-table-has-details">
                      <td role="cell">{{ data.item.ds_finalidade }}</td>
                    </tr>
                  </tbody>
                </div>
              </div>
              <div class="col-md-6 w-75">
                <div class="bg-soft bg-warning" style="width: 98%">
                  <thead role="rowgroup">
                    <tr role="row">
                      <th role="columnheader">Justificativa</th>
                    </tr>
                  </thead>
                  <tbody role="rowgroup">
                    <tr role="row" class="b-table-has-details">
                      <td role="cell">{{ data.item.ds_justificativa }}</td>
                    </tr>
                  </tbody>
                </div>
              </div>
            </div>
            <div class="accordion" role="tablist" data-v-step="5">
              <b-card
                v-for="(justificativa, index) in data.item.justificativa"
                :key="index"
                no-body
                class="mb-1"
              >
                <b-card-header header-tag="header" role="tab">
                  <i class="mdi mdi-subdirectory-arrow-right" />
                  <span class="m-0 text-dark" v-b-toggle="'info' + index">
                    {{ $tools.converteData(justificativa.dt_usuinc) }}
                    {{ justificativa.dt_usuinc.substr(11) }} -
                  </span>
                  <span
                    class="badge badge-pill font-size-12 m-1"
                    :class="{
                      'badge-soft-danger': justificativa.st_status === 'R',
                      'badge-soft-primary': justificativa.st_status === 'A',
                      'badge-soft-warning': justificativa.st_status === 'P',
                    }"
                  >
                    {{ $tools.statusDespesa(justificativa.st_status) }}
                  </span>
                </b-card-header>
                <b-collapse
                  :id="'info' + index"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <ul>
                      <li>
                        <strong>Responsável: </strong
                        >{{ justificativa.nm_usuinc }}
                      </li>
                      <li>
                        <strong>Observação: </strong>{{ justificativa.ds_obs }}
                      </li>
                    </ul>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </template>
        </b-table>

        <div class="row">
          <div class="d-flex justify-content-end px-1 mt-3">
            <div class="me-2 align-self-center mt-1">
              <router-link to="/cooperado/rdv">
                <b-button class="btn-lg"> Voltar </b-button>
              </router-link>
            </div>
          </div>
        </div>
      </b-card>
      <v-tour
        name="tourListaAdiantamento"
        :steps="stepsTour"
        :options="tourOptions"
        :callbacks="tourCallbacks"
      ></v-tour>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
export default {
  components: {
    PageHeader,
  },
  mounted() {
    if (this.executarTour) {
      this.$tours["tourListaAdiantamento"].start();
    }
  },
  data() {
    return {
      title: "Listagem de adiantamentos",
      items: [
        {
          text: "RDV4.0",
        },
        {
          text: "Listagem de adiantamentos",
          active: true,
        },
      ],
      executarTour: false,
      tourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Sair",
          buttonPrevious: "Anterior",
          buttonNext: "Próximo",
          buttonStop: "Sair",
        },
      },
      tourCallbacks: {
        onFinish: this.finalizarTour,
        onStop: this.finalizarTour,
      },
      stepsTour: [
        {
          target: '[data-v-step="1"]',
          content:
            "Aqui você pode ver a sua listagem com todas as informações do seu adiantamentos.",
          params: {
            placement: "top",
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: '[data-v-step="2"]',
          content: "Clique aqui para solicitar um novo Adiantamento.",
          params: {
            placement: "top",
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: '[data-v-step="3"]',
          content: "Aqui uma tabela detalhada dos seus adiantamentos.",
          params: {
            placement: "top",
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: '[data-v-step="4"]',
          content:
            "Aqui a Justificativa e a Finalidade do Uso do Adiantamento.",
          params: {
            placement: "top",
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: '[data-v-step="5"]',
          content: "Seu histórico de interações",
          params: {
            placement: "top",
            highlight: true,
            enableScrolling: false,
          },
        },
      ],
      currentPage: 1,
      rows: 0,
      rdvInfo: {},
      camposListaAdiantamento: [
        {
          key: "sq_id",
          label: "ID",
          class: "alinharCelulaDireita",
        },
        {
          key: "dt_solicitacao",
          label: "Data Solicitação",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "vl_solicitado",
          label: "Valor Solicitado",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "vl_analisado",
          label: "Valor Analisado",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "dt_pagamento",
          label: "Previsão Pagamento",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "status",
          label: "Status",
        },
      ],
      listaAdiantamento: [],
      listaAdiantamentoTour: [
        {
          sq_id: "999",
          dt_solicitacao: "9999-99-99",
          vl_solicitado: "9999",
          vl_analisado: "9999",
          dt_pagamento: "9999-99-99",
          status: "Aprovado",
          ds_finalidade:
            "Proin placerat suscipit erat eu lacinia. Nullam at dictum nulla.",
          ds_justificativa:
            "In quis maximus ante. Phasellus dapibus justo nulla. Proin ornare.",
          sq_gerdviag_adto_interacao: "",
          vl_interacao: "",
          justificativa: [
            {
              dt_usuinc: "99/99/9999 99:99:99",
              st_interacao: "Solicitado",
              sq_gerdiavg_adto_interacao: "9999",
              vl_interacao: "9999.9",
              ds_interacao:
                "In quis maximus ante. Phasellus dapibus justo nulla. Proin ornare 1",
              st_status: "Analisando",
              sq_usuinc: "1",
            },
            {
              dt_usuinc: "88/88/8888 88:88:88",
              st_interacao: "Solicitado",
              sq_gerdiavg_adto_interacao: "8888",
              vl_interacao: "8888.8",
              ds_interacao:
                "In quis maximus ante. Phasellus dapibus justo nulla. Proin ornare 2",
              st_status: "Analisando",
              sq_usuinc: "2",
            },
          ],
        },
      ],
      camposListaJustificativas: [
        {
          key: "sq_gerdiavg_adto_interacao",
          label: "Ano Interação",
        },
        {
          key: "vl_interacao",
          label: "Valor Interação",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "ds_interacao",
          label: "Descrição Adiantamento",
        },
        {
          key: "st_status",
          label: "Status",
        },
      ],
      ref: -1,
    };
  },
  created() {
    if (this.$store.state.rdvCooperado) {
      this.rdvInfo = this.$store.state.rdvCooperado;
      this.items.splice(1, 0, { text: this.rdvInfo.rdv.cd_rdv });
      this.items.splice(2, 0, {
        text: this.$tools.converteData(this.rdvInfo.rdv.dt_referencia),
      });
    } else {
      this.$router.push("/cooperado/rdv");
    }
    window.scrollTo(0, 0);
  },
  methods: {
    montaDetalhes(item) {
      item.forEach((el) => {
        if (el.status != "Aprovação do Tomador") {
          el._showDetails = true;
        }
      });
      return item;
    },
    abreFechaCollapse(index) {
      if (index == this.ref) {
        this.ref = -1;
      } else {
        this.ref = index;
      }
    },
    iniciarTour() {
      this.executarTour = true;
      this.listaAdiantamento = this.listaAdiantamentoTour;
      this.$tours["tourListaAdiantamento"].start();
    },
    finalizarTour() {
      this.listaAdiantamento = [];
      this.executarTour = false;
    },
  },
};
</script>